import store from "@/vue/planning/store/store"
import { getCookie, getParticipantsAmount } from "@/utils/utils"

export default {
    
    setSelectedPrestIds: ({state, getters, commit, dispatch}, {scrollToSummary = true, ...obj}) => {
        const prestations = getters.prestations
        const variants = getters.variants
        const selectedPrestationsAmount = getters.selectedPrestations.length
        const selectedPrestIds = state.selectedPrestIds

        Object.entries(obj).forEach(([id, quantity])=>{

            // find prestation and variant
            let prestation = prestations.find(prest=>{
                return !!prest.variants.find((v)=>{
                    return v.id===id
                })
            })
            let variant = variants.find(v=>v.id === id)
            if (!variant) throw new Error("prestation variant not found while adding selection")

            const currentQuantity = selectedPrestIds[id] || 0
            const difference = quantity - currentQuantity
            const company = getCookie('company')
            
            // unselect other variants
            prestation.variants.forEach((prestVariant)=>{
                if (prestVariant.id === id) return
                const unselectObject = {}
                unselectObject[prestVariant.id] = 0
                commit("setSelectedPrestIds", unselectObject)
            })

            const remainingAdditionalHebergements = getters.remainingAdditionalHebergements
            
            if (difference > 0) { // if adding - check for validity
                if (store.getters.locale === "fr_FR_CSE" && company === 'cgos' && selectedPrestationsAmount >= 1) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanOneOnCGOS'
                    )
                    return
                }
                if (store.getters.locale === "fr_FR_CSE" && company === 'cgos' && prestation.capacity < getParticipantsAmount()) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_lessPrestationThanAdultsCGOS'
                    )
                    return
                }
                if (remainingAdditionalHebergements === 0) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
                if (remainingAdditionalHebergements - difference < 0) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
                if (quantity > variant.quantity) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
            }

    
            // commit if entry is valid
            const object = {}
            object[id] = quantity
            commit("setSelectedPrestIds", object)
            
            // close dropdown
            commit("setSelectDropdownOpen_prestId", {id:'', current_select_location:''})
        })

        if (!state.scrollToPrestationFired && scrollToSummary) {
            setTimeout(()=>{
                window.dispatchEvent(new CustomEvent("smoothScrollToSelector", {detail: {selector: "#summary", block: "center"}}))
            }, 200)
            commit("setScrollToPrestationFired", true)
        }

        dispatch("refreshDataStoredOnWindow")
    },

}